"use client";

import { brandImage } from "@/lib/brand";
import { cn } from "@/lib/utils";
import Image from "next/image";

export function BrandHeaderLogo({ className }: { className?: string }) {
  return (
    <Image
      src={brandImage.horizontal.src}
      alt="darsi.ma"
      width={brandImage.horizontal.width}
      height={brandImage.horizontal.height}
      className={cn("h-7 w-auto object-contain sm:h-8", className)}
      priority
    />
  );
}
